<template>
  <div class="incomeHomeServiceLabor">
    <!-- 添加表格 -->
    <el-card>
      <div slot="header" style="float: left;font-size: 24px;text-align: left; display: flex;" v-if="tableData.length>0">
        <div style="margin-left: 40px;">{{nowYear}}年收入：{{tableData[0].thisYear}}</div>
        <div style="margin-left: 40px;">{{oneYear}}年收入：{{tableData[0].lastYear}}</div>
        <div style="margin-left: 40px;">{{twoYear}}年收入：{{tableData[0].beforeLastYear}}</div>
      </div>
      <el-button type="primary" slot="header" @click="jump()">{{$t('lang.btn_retIncomeList')}}</el-button>
      <el-table
        :data="tableData"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
      <!-- checkbox -->
        <el-table-column type="selection" width="55" v-if="this.incomeHomeServiceLaborDtlcheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column
          type="index"
          :index="indexMethod" align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <!-- 工单单号 -->
        <el-table-column prop="maintainId" :label="$t('lang.lab_workNum')"></el-table-column>
        <!-- 工单金额 -->
        <el-table-column prop="amountOfWork" sortable :label="$t('lang.lab_workAmont')"></el-table-column>
        <!-- 工单提成 -->
        <el-table-column prop="incomeFromLabor" sortable :label="$t('lang.lab_workCommission')"></el-table-column>
      </el-table>
      <!-- 添加页码 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:communityManagement
 *@Description:居家服务劳动所得
 *@author:李斌
 *@Copyright:格众科技
 *@date:2020-03-04
 */
export default {
  // 默认显示数据
  data() {
    return {
      incomeHomeServiceLaborDtlcheckbox: require('@/config/enum').incomeHomeServiceLaborcheckbox, // 是否隐藏复选框
      tableData: [], // 表单数据
      pageCount: 0, // 总页数
      pageSize: 10, // 每页显示数量
      pageNum: 1, // 页数
      multipleSelection: [], // 多选框
      maintainId: '', // 工单单号
      amountOfWork: '', // 工单金额
      incomeFromLabor: '', // 工单提成
      id: '', // 跳转页面参数
      nowYear: new Date().getFullYear(), // 今年
      oneYear: new Date().getFullYear() - 1, // 去年
      twoYear: new Date().getFullYear() - 2, // 前年
    }
  },
  // 初始化
  created() {
    this.id = this.$route.query.id
    this.topics()
  },
  methods: {
    // ID序号功能
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    // 列表斑马线
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    topics() {
      let loading = this.$loading()
      this.$get(
        `/getServiceCommissionDetailsByStaffId?pageNo=${this.pageNum}&pageSize=${this.pageSize}&staffId=${this.id}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 跳转回列表页面
    jump() {
      this.$router.push({ name: 'incomeHomeServiceLaborList' })
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNum = val
      this.topics()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.topics()
    }
  }
}
</script>

<style lang= 'scss'>
</style>